module.exports = __webpack_public_path__ + "img/eyebrow.33fa1ec8.svg";